export { default } from './svg/form.svg';
